import { lazy, Suspense } from "react";
import { Header } from "@/components/layout/Header";
import { Hero } from "@/components/sections/Hero";

import { AnalyticsProvider } from "@/components/analytics/AnalyticsProvider";
import { TrackingScripts } from "@/components/tracking/TrackingScripts";
import { PageSEO } from "@/components/seo/PageSEO";
import { SchemaMarkup } from "@/components/seo/SchemaMarkup";
import { FloatingWhatsApp } from "@/components/sections/FloatingWhatsApp";
import { StickyCTA } from "@/components/sections/StickyCTA";
import { ExitIntentPopup } from "@/components/sections/ExitIntentPopup";

const Services = lazy(() => import("@/components/sections/Services").then(m => ({ default: m.Services })));
const Results = lazy(() => import("@/components/sections/Results").then(m => ({ default: m.Results })));
const About = lazy(() => import("@/components/sections/About").then(m => ({ default: m.About })));
const FAQ = lazy(() => import("@/components/sections/FAQ").then(m => ({ default: m.FAQ })));
const CTA = lazy(() => import("@/components/sections/CTA").then(m => ({ default: m.CTA })));
const Footer = lazy(() => import("@/components/layout/Footer").then(m => ({ default: m.Footer })));

const Index = () => {
  return (
    <AnalyticsProvider>
      <TrackingScripts />
      <PageSEO
        title="NeoSDR — Terceirização de Pré-vendas B2B"
        description="SDRs especializados para gerar reuniões qualificadas. Terceirize sua pré-venda e foque no fechamento."
        canonical="https://neosdr.online/"
      />
      <SchemaMarkup type="Service" />
      <div className="min-h-screen">
        <Header variant="outsourcing" />
        <StickyCTA />
        <main>
          <Hero />
          
          <Suspense fallback={null}>
            <Services />
            <Results />
            <About />
            <FAQ />
            <CTA />
          </Suspense>
        </main>
        <Suspense fallback={null}>
          <Footer variant="outsourcing" />
        </Suspense>
        <FloatingWhatsApp />
        <ExitIntentPopup />
      </div>
    </AnalyticsProvider>
  );
};

export default Index;
